import $ from 'jquery' /*引入jquery*/
import '../swiper.min.js' /*引入swiper滑动&轮播插件,只需引用一次*/

export default {
    initSwiper,
    getCookie,
    setCookie,
    getActiveCityName
}

/**
 * 初始化swiper轮播对象,主要判断一下该对象是否需要轮播初始化
 * 
 * @param  {Object || String} selector
 * jquery选择器或者jquery对象,需要初始化的对象
 * 
 * @param  {Object}           config
 * 参照swiper中文网, 传入对应的配置对象
 * 
 * @return {Array || Object}
 * 如果初始化的对象是个数组则返回数组, 如果是单一对象则返回一个对象
 */
function initSwiper(selector, config) {
    var returnArr = [],
        sildeClass = config.slideClass ? '.'+config.slideClass : '.swiper-slide'
    $(selector).each(function(i, e){
        if($(e).find(sildeClass).length > 1) {
            returnArr.push(
				new Swiper($(e), config)
			)
        }
    })
    return returnArr.length > 1 ? returnArr : returnArr[0]
}

/**
 * 根据cookie名称获取值
 * 
 * @param  {String} name 希望获得cookie名字
 * 
 * @return {String}      对应的cookie值
 */
function getCookie(name) {
    var arr,
        reg=new RegExp('(^| )'+name+'=([^;]*)(;|$)')
    if(arr = document.cookie.match(reg)) {
        return decodeURIComponent(arr[2])
    }else {
        return null
    }
}

/**
 * 添加或修改cookie
 * 
 * @param {String} name  cookie名字
 * @param {String} value cookie值
 * @param {Number} day   cookie时效(可省略,默认30天)
 */
function setCookie(name, value, day) {
    var Days = day || 30
    var exp = new Date()
    exp.setTime(exp.getTime() + Days*24*60*60*1000)
    document.cookie = name + '='+ encodeURIComponent(value) + ';expires=' + exp.toGMTString()
}

/**
 * 获取当前页面城市参数
 * @return {String} 
 * 当前页面城市参数(拼音简称), eg:北京->bj, 天津->tj
 */
function getActiveCityName() {
    return ____json4fe.locallist[0].listname
}

export const judgeShow = function (dom) {
    return new Promise(function (resolve, reject) {
        if (typeof dom !== 'object') reject('dom节点不合法！')
        let scrollTop
        const docH = Math.max(document.documentElement.clientHeight, document.body.clientHeight),
            domOffSetTop = $(dom).offset().top,
            handleWindowScroll = (e) => {
                scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop)
                if (domOffSetTop < scrollTop + docH + 100) {
                    window.removeEventListener('scroll', handleWindowScroll)
                    resolve()
                }
            }
        handleWindowScroll()
        window.addEventListener('scroll', handleWindowScroll)
    })
}
